module.exports = __webpack_public_path__ + "static/img/12.c74c7fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/sp/12.png
// module id = fOOP
// module chunks = 0